import React, {useContext, useEffect, useState} from 'react'
import GeneralInfoExpansionPanelTitle from "./GeneralInfoExpansionPanelTitle";
import Tr from "translations/Translations";
import ExpansionPanel from "components/ExpansionPanel";
import DemandOffersGeneralInfoService from "services/DemandOffersGeneralInfoService";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import Loading from "components/Loading";
import GeneralInfoPublicAnswersMessage from "./GeneralInfoPublicAnswersMessage";
import PropTypes from "prop-types";
import PurchaserOfferContext from "context/PurchaserOfferContext";
import DemandOffersService from "services/DemandOffersService";
import {StageSections} from "../../../../constants/StageSections";
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    messagesDiv: {
        width: '90%'
    }
}));

function GeneralInfoPublicAnswers(
    {
        match,
        panelsClassesObject,
        currentRfxRoundId,
        generalInfoPublicAnswers,
        demandStageSectionsList
    }) {
    const classes = useStyles();
    const [expanded, setExpanded] = useState(false);
    const demandId = match.params.id;
    const stageId = match.params.stageId;
    const purchaserOfferContext = useContext(PurchaserOfferContext);
    const unreadAnswers = demandStageSectionsList[StageSections.GENERAL_INFO].unreadRfxMessages;

    useEffect(() => {
        if (expanded && generalInfoPublicAnswers === undefined)
            DemandOffersGeneralInfoService.getContractorGeneralInfoPublicAnswers(demandId, stageId, purchaserOfferContext?.supplierId);
        return () => {
            DemandOffersGeneralInfoService.clearResources(DemandOffersGeneralInfoService.GENERAL_INFO_PUBLIC_ANSWERS);
        }
        // eslint-disable-next-line
    }, [expanded])


    return (
        <ExpansionPanel
            classesObj={panelsClassesObject}
            title={
                <GeneralInfoExpansionPanelTitle
                    subject={Tr("answer_on_question")}
                    unreadElements={unreadAnswers}
                    toggleThread={() => setExpanded(x => !x)}
                    expanded={expanded}
                />
            }
            expanded={expanded}
            onChange={(e, isExpanded) => setExpanded(isExpanded)}

        >
            {
                !generalInfoPublicAnswers ?
                    <Loading/>
                    :
                    <div className={classes.messagesDiv}>
                        {
                            generalInfoPublicAnswers.map((x, i ) => (<GeneralInfoPublicAnswersMessage key={x.messageId} demandId={demandId} index={i+1} message={x} currentRfxRoundId={currentRfxRoundId} />))
                        }
                    </div>


            }
        </ExpansionPanel>
    )
}

GeneralInfoPublicAnswers.propTypes = {
    currentRfxRoundId: PropTypes.number.isRequired
}

export default connect((state) => ({
    generalInfoPublicAnswers: state.resources[DemandOffersGeneralInfoService.GENERAL_INFO_PUBLIC_ANSWERS],
    demandStageSectionsList: state.resources[DemandOffersService.DEMAND_STAGE_SECTIONS_LIST]
}), {})(withRouter(GeneralInfoPublicAnswers));